import { render, staticRenderFns } from "./ListMakanan.vue?vue&type=template&id=a18029b4&scoped=true"
import script from "./ListMakanan.vue?vue&type=script&lang=js"
export * from "./ListMakanan.vue?vue&type=script&lang=js"
import style0 from "./ListMakanan.vue?vue&type=style&index=0&id=a18029b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18029b4",
  null
  
)

export default component.exports